import Index from 'src/pages/Labels/Index.vue'

const auth = { requiresAuth: true }

export default [
  {
    path: '/labels',
    name: 'Etiketten',
    component: Index,
    meta: auth
  }
]
